import React, { useEffect, useState } from 'react';
import HomeItem from '@/pages/agency/home/components/home-item/index.tsx';
import './style.scoped.less';
import actions from '@/pages/saleTarget/api';
import globalStore from '@/stores';
import { withAccount } from '@/business-components/operator/account-context';
import perms from '@/common/permissions/sale/perms';

const Todo = (props) => {
  const {
    title,
    account: { saleStatus },
  } = props;
  const { grayPermissions = [] } = saleStatus || {};
  const [data, setData] = useState({
    notCleanLeadsNum: 0,
    notHandlePotentialsNum: 0,
    marketLeadNotCleanNum: 0,
    marketPotentialFollowNum: 0,
  });

  const {
    notCleanLeadsNum,
    notHandlePotentialsNum,
    marketLeadNotCleanNum,
    marketPotentialFollowNum,
  } = data;

  const handleToCleanLeads = () => {
    window.open('leads?cleaningStatus=CLEANING_STATUS_PENDING');
  };

  const handleToTodoPotentials = () => {
    window.open('potentials?potentialStatus=POTENTIAL_STATUS_NEW');
  };

  const handleToLeads = () => {
    window.open('leads');
  };

  const handleToPotentials = () => {
    window.open('potentials');
  };

  useEffect(() => {
    // 没有服务商id 不是销售，不请求
    if (!globalStore?.account?.sale_agency_uid) {
      return null;
    }
    // 没有灰度 返回空
    console.log('是否销售首页灰度服务商', grayPermissions.includes(perms.GRAY_SEAS_HOME_SALE_DATA));
    if (!grayPermissions.includes(perms.GRAY_SEAS_HOME_SALE_DATA)) {
      return null;
    }
    actions.myTodoOverView().then((res) => {
      setData(res.data);
    });
  }, []);

  // 没有服务商id 不是销售，不展示相关内容
  if (!globalStore?.account?.sale_agency_uid) {
    return null;
  }

  // 没有灰度 返回空
  if (!grayPermissions.includes(perms.GRAY_SEAS_HOME_SALE_DATA)) {
    return null;
  }

  return (
    <HomeItem
      header={(
        <>
          <div className="title">{title}</div>
        </>
      )}
    >
      <div className="home-sale-todo">
        <section onClick={handleToCleanLeads}>
          <p>待清洗线索</p>
          <div className="todo-message-content">
            <span>{notCleanLeadsNum || 0}</span>
            <span>条</span>
          </div>
        </section>
        <section onClick={handleToTodoPotentials}>
          <p>待处理商机</p>
          <div className="todo-message-content">
            <span>{notHandlePotentialsNum || 0}</span>
            <span>条</span>
          </div>
        </section>
        <section onClick={handleToLeads}>
          <p>线索跟进提醒</p>
          <div className="todo-message-content">
            <span>{marketLeadNotCleanNum || 0}</span>
            <span>条</span>
          </div>
        </section>
        <section onClick={handleToPotentials}>
          <p>商机跟进提醒</p>
          <div className="todo-message-content">
            <span>{marketPotentialFollowNum || 0}</span>
            <span>条</span>
          </div>
        </section>
      </div>
    </HomeItem>
  );
};

export default withAccount(Todo);
